import {usePatientContext} from '@/shared/contexts/patient-context'
import {Drawer, Tabs} from '@chakra-ui/react'
import {DrawerBody, DrawerFooter, DrawerHeader} from '@cypro/ui/components'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {useTranslate} from '@tolgee/react'
import {PatientSummary} from './patient-summary'
import {PatientDrawerTabsList} from './tabs-list'
import {AboutTab} from './tabs/about'
import {HistoryTab} from './tabs/history'

export function PatientDrawer() {
  const {t} = useTranslate('common')
  const {patient} = usePatientContext()

  return (
    <>
      <DrawerHeader>
        <Drawer.Title>{t('patient_details')}</Drawer.Title>
      </DrawerHeader>

      <DrawerBody height="100%" flex="1 1 0%" spaceY="5">
        <PatientSummary />

        <Tabs.Root defaultValue="about" spaceY="5">
          <PatientDrawerTabsList />

          <AboutTab />
          <HistoryTab />
        </Tabs.Root>
      </DrawerBody>

      <DrawerFooter>
        {patient && (
          <LinkButton
            to="/patient-dashboard/patients/$patientId"
            params={prev => ({...prev, patientId: patient.id})}
            search={{tab: 'therapy'}}
            colorPalette="cyan"
          >
            {t('view_patient_profile')}
          </LinkButton>
        )}
      </DrawerFooter>
    </>
  )
}
